export const COLOR_REAL_BLACK = '#000';
export const COLOR_BLACK = '#242424';
export const COLOR_WHITE = '#ffffff';
export const COLOR_GREY = '#757575';
export const COLOR_GREY2 = '#cacaca';
export const COLOR_GREY3 = '#5d5d6c';
export const COLOR_GREY4 = '#eaeaea';
export const COLOR_GREY5 = '#8d93a3';
export const COLOR_MEDIUM_GREY = '#dfdfe5';
export const COLOR_LIGHT_GREY = '#fafafa';
export const COLOR_PURPLE = '#674eea';
export const COLOR_MAGENTA = '#f4ebf3';
export const COLOR_BLUE_MAGENTA = '#9469ad';
export const COLOR_BLUE_MAGENTA_SATURATED_SHADE = '#dad3fe';
export const COLOR_BLUE_MAGENTA_LIGHT = '#f0edfd';
export const COLOR_LIGHT_PURPLE = '#8f79ff';
export const COLOR_DARK_PURPLE = '#2A24A4';
export const COLOR_DARK_PURPLE_TEXT = '#2A24A4';
export const COLOR_CYAN = '#58c1de';
export const COLOR_DARK_CYAN = '#26aed3';
export const COLOR_RED = '#ff2b2b';
export const COLOR_MEDIUM_RED = '#fccfcf';
export const COLOR_LIGHT_RED = '#fff5f5';
export const COLOR_GREEN = '#24a676';
export const COLOR_LIGHT_GREEN = '#e9f6f1';
export const COLOR_BLUE = '#4e94c2';
export const COLOR_LIGHT_BLUE = '#e5eff6';
export const COLOR_DARK_BLUE = '#240f94';
export const COLOR_HEAVY_DARK_BLUE = '#0a163a';
export const COLOR_LIGHT_GREEN_BACK = '#D3EDE4';
export const COLOR_BROWN = '#ae6f48';
export const COLOR_YELLOW = '#ffd815';
export const COLOR_LIGHT_BROWN = '#f3eae4';
export const COLOR_BUTTON_PASS = '#eaeaea';
export const COLOR_POPULAR_SCHOOLS_HOVER = '#EAEAEA';
export const COLOR_DARKNEST_PURPLE = '#2A244A';
export const COLOR_INPUT_BORDER = COLOR_GREY4;
export const COLOR_PLACEHOLDER = COLOR_GREY5;
export const COLOR_FOOTER_MOBILE_TEXT = '#2a244a';
export const COLOR_POPULAR_SCHOOLS_BACKGROUND = '#f6f6f6';
export const COLOR_CURIOSITY_BUTTON_BORDER = '#bababa';
export const COLOR_CURIOSITY_BUTTON_BACKGROUND = '#eceafb';
export const COLOR_SELECT_BACKGROUND = '#eceafb';
export const FROSH_BUTTON_BACKGROUND = '#1589CE';
export const FROSH_BUTTON_BACKGROUND_HOVER = '#2c94d2';
export const EDIT_BUTTON_BLUE = '#664EEA';
export const EDIT_BUTTON_BLUE_DISABLE = '#B3A6F4';
